export default __webpack_public_path__ + "static/media/default-logo.f0253b90.png";